var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Id } from "core/utils";
export var View = function (_a) {
    var html = _a.html, displayMode = _a.displayMode, bgColor = _a.bgColor, className = _a.className;
    return (React.createElement(Container, { className: className, "data-component": Id.component.embed.qualifio[Id.displayModeMapper(displayMode)], dangerouslySetInnerHTML: { __html: html }, displayMode: displayMode, bgColor: bgColor }));
};
var Container = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  text-align: center;\n\n  ", "\n\n  ", "\n\n  iframe {\n    ", "\n  }\n"], ["\n  width: 100%;\n  text-align: center;\n\n  ", "\n\n  ", "\n\n  iframe {\n    ", "\n  }\n"])), function (props) { return props.displayMode !== "Slot" && "flex-grow: 1;"; }, function (props) { return props.bgColor && "background-color: ".concat(props.bgColor, ";"); }, function (props) {
    return props.displayMode !== "Slot" &&
        "width: 100%;\n    max-width: none !important;";
});
var templateObject_1;
